import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";

export const firebaseConfig = {
  apiKey: "AIzaSyCHJtyYG-dI3fKEQNeXAu9755rBP0aVeoU",
  authDomain: "personal-site-mk-1.firebaseapp.com",
  projectId: "personal-site-mk-1",
  storageBucket: "personal-site-mk-1.appspot.com",
  messagingSenderId: "48289643119",
  appId: "1:48289643119:web:274a547d3bdca72225ab9a",
  measurementId: "G-4RENQN9KXS",
};

if (firebase.apps.length === 0) {
  firebase.initializeApp(firebaseConfig);
}

export const db = firebase.firestore();

export default firebase;

